import './socials.scss'
import { loadSvg } from 'js/utility/image.js'

export const component = {
    name: 'socials',

    mounted () {
        this.socials.forEach( (social, i) => {
            const iconUrl = `${window.__themeUrl}/assets/svg/social/${social.social_icon}`
            Promise.resolve()
                .then(() => loadSvg(iconUrl))
                .then(svg => { this.socials[i].icon = svg.outerHTML })
        } )
    }
}


// WEBPACK FOOTER //
// ./app/theme/components/socials/socials.js